import { gql } from '@apollo/client'

export default gql`
  mutation course_homeworks_delete($id: ID!) {
    courseHomeworkDelete(id: $id) {
      id
    }
  }
`
